import React from "react";
import { Fragment } from "react";
import Close from '../assets/icons/cancel icon-01.svg'
const Modal = ({ body, closeHandler }) => {
  return (
    <Fragment>
      <div
        className="w-full h-full bg-gray-800  opacity-60 fixed top-0 left-0 z-10"
        onClick={closeHandler}
      />

      <div className="z-20  w-64 relative  h-full  overflow-hidden rounded-2xl screen500:w-48  ">
        <header className=" bg-[#d8d53c] py-5 screen500:py-4 ">
          <div
            className="float-left cursor-pointer mx-4 text-sm -mt-2  text-white screen500:text-[10px]"
            onClick={closeHandler}
          >
            <img src={Close} className="w-4 h-4 " />
          </div>
        </header>

        <main className=" py-2 bottom-0   bg-white screen500:py-1">
          <div className="text-gray-600 align-middle text-justify px-5 text-sm py-2 screen500:text-[10px]">
            {body}
          </div>
        </main>

        <footer className=" py-2 bg-[#d8d53c]   text-white ">
          <div className="text-right px-5 text-xs screen500:text-[10px]">
            صرافی روبین
          </div>
        </footer>
      </div>
    </Fragment>
  );
};

export default Modal;
